export const popupTransition =
  "transition-[opacity,scale,translate] duration-150 ease-out origin-(--transform-origin) data-starting-style:opacity-0 data-starting-style:scale-[0.96] data-ending-style:opacity-0 data-ending-style:scale-[0.98] data-ending-style:duration-100";
